define('datakit/util/url',['require','exports','module','backbone','underscore'],function(require, exports, module) {
  //prettier-ignore
  var Backbone = require('backbone'),
      _        = require('underscore');

  var namedParam = /:([^\d][\w\.]+)/g;

  var url = {
    template: function(urlPath) {
      var sources = _.rest(arguments);
      return String(urlPath == null ? '' : urlPath).replace(namedParam, function(match, name) {
        for (var i = 0, isModel, source; i < sources.length; i++) {
          source = sources[i];
          isModel = source instanceof Backbone.Model;
          if (isModel ? source.has(name) : _.has(source, name)) {
            return encodeURIComponent(isModel ? source.get(name) : source[name]);
          }
        }
      });
    },

    compile: function(urlPath) {
      return function() {
        var args = _.toArray(arguments);
        return url.template.apply(url, [urlPath].concat(args));
      };
    },
  };

  module.exports = url;
});

